import {NgModule} from '@angular/core';

import {LoginComponent} from './login/login.component';
import {RegisterComponent} from './register/register.component';

import {AccountRoutingModule} from './account-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AuthenticationService} from '../../services/authentication.service';
import {ResetPasswordComponent} from './reset/reset-password.component';
import {ResetPasswordInitComponent} from './reset/reset-password-init.component';
import {AccountCreatedComponent} from './register/account-created.component';
import {LogoutComponent} from './logout/logout.component';
import {CommonModule} from '@angular/common';

@NgModule({
  imports: [
    AccountRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    LoginComponent,
    LogoutComponent,
    RegisterComponent,
    ResetPasswordComponent,
    ResetPasswordInitComponent,
    AccountCreatedComponent
  ],
  providers: [
    AuthenticationService
  ]
})
export class AccountModule { }
